var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeEar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144.95 188.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffc300;}.cls-2{fill:#ff3b83;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icone_Resume_new",
    "data-name": "Icone Resume new"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_3",
    "data-name": "Livello 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.49,188.63c-21.76-.29-38.92-6.88-51-19.59C54.11,148.67,54.93,120.17,55,119v-74a44.93,44.93,0,1,1,89.85,0V85h-6.21v-40a38.72,38.72,0,0,0-77.44,0v73.71c0,.82-.73,27.73,16.84,46.17,10.89,11.42,26.55,17.35,46.56,17.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.9,102.64V96.43A20.13,20.13,0,0,0,120,76.32V45.61c0-9.9-6.69-18.46-15.89-20.36A20.13,20.13,0,0,0,79.74,44.93H73.53a26.32,26.32,0,0,1,31.84-25.75c12.08,2.48,20.84,13.6,20.84,26.43V76.32A26.34,26.34,0,0,1,99.9,102.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.35,149.17A26.34,26.34,0,0,1,81,122.86V92.15c0-12.84,8.77-24,20.84-26.44l1.25,6.08c-9.2,1.9-15.89,10.45-15.89,20.36v30.71A20.13,20.13,0,0,0,107.35,143Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.53,188.63A20.42,20.42,0,1,1,145,168.22,20.43,20.43,0,0,1,124.53,188.63Zm0-34.62a14.21,14.21,0,1,0,14.21,14.21A14.22,14.22,0,0,0,124.53,154Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 138.68,
    y: 84.95,
    width: 6.21,
    height: 83.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 94.01,
    width: 33.26,
    height: 6.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.79,
    y: 28.2,
    width: 6.2,
    height: 33.26,
    transform: "translate(-26.17 26.49) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.26,
    y: 143,
    width: 33.26,
    height: 6.2,
    transform: "translate(-97.77 56.15) rotate(-45)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeEar);
export default __webpack_public_path__ + "static/media/home-ear.4914901dac3e7629fc00382edf553c84.svg";
export { ForwardRef as ReactComponent };